import { Navigate, useSearchParams } from 'react-router-dom';


// Back-compat redirect: the old /compliance/tprm/register page has been
// folded into the tabbed /compliance/tprm Data tab. External bookmarks and
// any lingering internal links keep working by forwarding here with their
// query string preserved.
export default function TprmRegisterRedirect() {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  next.set('tab', 'data');
  return <Navigate to={`/compliance/tprm?${next.toString()}`} replace />;
}
